import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
export function StaticHtmlPage() {
  const location = useLocation();
  const [html, setHtml] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setLoading(true);
    setError(false);
    setHtml(null);
    // Build the path to the static HTML file
    let htmlPath = location.pathname;
    if (!htmlPath.endsWith('/')) {
      htmlPath += '/';
    }
    htmlPath += 'index.html';
    fetch(htmlPath).then(res => {
      if (!res.ok) throw new Error('Not found');
      return res.text();
    }).then(text => {
      // Extract content between <body> and </body>
      const bodyMatch = text.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
      const styleMatch = text.match(/<style[^>]*>([\s\S]*?)<\/style>/gi);
      const titleMatch = text.match(/<title[^>]*>([\s\S]*?)<\/title>/i);
      let bodyContent = bodyMatch ? bodyMatch[1] : text;
      let styles = styleMatch ? styleMatch.join('\n') : '';
      // Set document title if found
      if (titleMatch && titleMatch[1]) {
        document.title = titleMatch[1].trim();
      }
      const navHtml = `
<nav style="padding:16px; border-bottom:1px solid #eee; background: #fff;">
  <a href="/" style="margin-right:20px; color: #000; text-decoration: none;">Home</a>
  <a href="/blog" style="margin-right:20px; color: #000; text-decoration: none;">Blog</a>
  <a href="/about" style="margin-right:20px; color: #000; text-decoration: none;">About</a>
  <a href="/faq" style="margin-right:20px; color: #000; text-decoration: none;">FAQ</a>
</nav>
`;
      // Combine styles and body content
      const fullContent = styles + navHtml + bodyContent;
      setHtml(fullContent);
      setLoading(false);
    }).catch(() => {
      setError(true);
      setLoading(false);
    });
  }, [location.pathname]);
  // Scroll to top on navigation
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  if (loading) {
    return <div className="flex items-center justify-center min-h-screen bg-[#050505]" data-id="element-10288">
        <div className="flex flex-col items-center gap-4" data-id="element-10289">
          <div className="w-8 h-8 border-2 border-red-500 border-t-transparent rounded-full animate-spin" data-id="element-10290" />
          <span className="text-gray-400 text-sm font-mono tracking-wider" data-id="element-10291">
            LOADING...
          </span>
        </div>
      </div>;
  }
  if (error || !html) {
    return <div className="flex items-center justify-center min-h-screen bg-[#050505]" data-id="element-10292">
        <div className="text-center" data-id="element-10293">
          <h1 className="text-2xl font-bold text-white mb-4" data-id="element-10294">Page Not Found</h1>
          <p className="text-gray-400 mb-6" data-id="element-10295">This page could not be loaded.</p>
          <a href="/" className="inline-block bg-[#FF0000] text-white px-6 py-3 font-bold text-sm uppercase tracking-widest hover:bg-red-600 transition-all" data-id="element-10296">
            Go Home
          </a>
        </div>
      </div>;
  }
  return <div ref={containerRef} className="static-html-page" dangerouslySetInnerHTML={{
    __html: html
  }} data-id="element-10297" />;
}